module.exports = __webpack_public_path__ + "static/media/problemFace.a3715791.svg";